// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.abra",
    name: "Abra Wallet",
    homepage: "https://abra.com",
    image_id: "2219db01-e0c9-471c-5def-fd3b4e7a7a00",
    app: {
        browser: "https://abra.com",
        ios: "https://abra.com",
        android: "https://abra.com",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "abra://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map